import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class SecondaryPaths {
  static msr = new EnhancedPath('/msr');
  static marketToMarket = new EnhancedPath('/market-to-market');
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: SecondaryPaths.msr.path,
      component: lazyWithRetry(() => import('app/pages/system/msr')),
      pageCode: PAGE_CODES.MSR,
      exact: true,
    },
    {
      path: SecondaryPaths.marketToMarket.path,
      component: lazyWithRetry(() => import('app/pages/system/marketToMarket')),
      exact: true,
      pageCode: PAGE_CODES.MARK_TO_MARKET,
    },
  ],
};

export default routesConfig;
